import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 break-setting" }
const _hoisted_2 = { class: "font-size-24 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-2" }, null, -1)
const _hoisted_4 = { class: "mb-2 font-size-14 font-bold" }
const _hoisted_5 = { class: "mt-8 w-2/5 mb-6" }
const _hoisted_6 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_7 = { class: "mr-2 mt-3" }
const _hoisted_8 = { class: "mr-2" }
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = {
  key: 1,
  class: "mt-8 w-2/5"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "font-size-14 font-bold mb-2 mt-8" }
const _hoisted_15 = { class: "w-2/5" }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "font-size-14 font-bold mb-2 mt-8" }
const _hoisted_18 = { class: "w-2/5" }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "font-size-14 font-bold mb-2 mt-8" }
const _hoisted_21 = { class: "w-2/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Label = _resolveComponent("Label")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('breakSetting')), 1),
    _hoisted_3,
    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('stampingBreak')), 1),
    _createVNode("div", null, [
      _createVNode(_component_RadioGroup, {
        class: "mt-2",
        "options-radio": _ctx.stampingBreakList,
        modelValue: _ctx.workingStyleMasterParams.is_using_break_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workingStyleMasterParams.is_using_break_time = $event))
      }, null, 8, ["options-radio", "modelValue"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Label, {
        "text-label": _ctx.t('breakType')
      }, null, 8, ["text-label"]),
      _createVNode(_component_Select, {
        placeholder: _ctx.t('placeholderSelect'),
        "options-select": 
          _ctx.workingStyleMasterParams.is_using_break_time ===
          _ctx.USING_BREAK_TIME.NOT_USE
            ? _ctx.typeBreakList
            : _ctx.typeBreakStampedList
        ,
        "item-value": "key",
        modelValue: _ctx.workingStyleMasterParams.break_type,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.workingStyleMasterParams.break_type = $event))
      }, null, 8, ["placeholder", "options-select", "modelValue"])
    ]),
    (
        _ctx.workingStyleMasterParams.break_type === _ctx.BREAK_TYPE.BREAK_AUTOMATICALLY
      )
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_Label, {
            "text-label": _ctx.t('automaticBreak')
          }, null, 8, ["text-label"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workingStyleMasterParams.working_style_standard_automatic_breaks, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "flex mb-5",
              key: index,
              id: item
            }, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t('workingHours')), 1),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_InputTime, {
                  width: "96px",
                  modelValue: 
              _ctx.workingStyleMasterParams.working_style_standard_automatic_breaks[
                index
              ].working_time
            ,
                  "onUpdate:modelValue": ($event: any) => (
              _ctx.workingStyleMasterParams.working_style_standard_automatic_breaks[
                index
              ].working_time
             = $event),
                  validated: _ctx.validated,
                  "error-server": 
              _ctx.errorServerData[
                `working_style_standard_automatic_breaks.${index}.working_time`
              ]
            ,
                  errors: 
              _ctx.errorsData[
                `working_style_standard_automatic_breaks.${index}.working_time`
              ]
            ,
                  "onUpdate:errors": ($event: any) => (
              _ctx.errorsData[
                `working_style_standard_automatic_breaks.${index}.working_time`
              ]
             = $event),
                  required: 
              !!_ctx.workingStyleMasterParams
                .working_style_standard_automatic_breaks[index].break_time
            
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('moreThanMinutes')), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "validated", "error-server", "errors", "onUpdate:errors", "required"])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_InputTime, {
                  width: "96px",
                  modelValue: 
              _ctx.workingStyleMasterParams.working_style_standard_automatic_breaks[
                index
              ].break_time
            ,
                  "onUpdate:modelValue": ($event: any) => (
              _ctx.workingStyleMasterParams.working_style_standard_automatic_breaks[
                index
              ].break_time
             = $event),
                  validated: _ctx.validated,
                  "error-server": 
              _ctx.errorServerData[
                `working_style_standard_automatic_breaks.${index}.break_time`
              ]
            ,
                  errors: 
              _ctx.errorsData[
                `working_style_standard_automatic_breaks.${index}.break_time`
              ]
            ,
                  "onUpdate:errors": ($event: any) => (
              _ctx.errorsData[
                `working_style_standard_automatic_breaks.${index}.break_time`
              ]
             = $event),
                  required: 
              !!_ctx.workingStyleMasterParams
                .working_style_standard_automatic_breaks[index].working_time
            
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('oneMinuteBreak')), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "validated", "error-server", "errors", "onUpdate:errors", "required"])
              ]),
              (
            _ctx.workingStyleMasterParams.working_style_standard_automatic_breaks
              .length > 1
          )
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "cp-icon-minus-circle text-2xl cursor-pointer text-red-ff hover:opacity-75 mr-2 mt-3 h-fit-content",
                    onClick: ($event: any) => (_ctx.removeAutomaticBreak(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isAddBreakTime(index))
                ? (_openBlock(), _createBlock("span", {
                    key: 1,
                    class: "mt-3 text-light-blue cursor-pointer hover:opacity-75 cp-icon-plus-circle text-2xl h-fit-content",
                    onClick: ($event: any) => (_ctx.addBreakTime(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 8, ["id"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.workingStyleMasterParams.break_type === _ctx.BREAK_TYPE.BREAK_AUTOMATICALLY
      )
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode(_component_Label, {
            "text-label": _ctx.t('priorityOfAutomaticBreaks')
          }, null, 8, ["text-label"]),
          _createVNode(_component_Select, {
            "item-value": "key",
            placeholder: _ctx.t('placeholderSelect'),
            "options-select": _ctx.priorityList,
            modelValue: 
          _ctx.workingStyleMasterParams.working_style_standard.break_time_priority
        ,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (
          _ctx.workingStyleMasterParams.working_style_standard.break_time_priority
         = $event))
          }, null, 8, ["placeholder", "options-select", "modelValue"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.workingStyleMasterParams.break_type === _ctx.BREAK_TYPE.BREAK_AUTOMATICALLY
      )
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('autoBreakAndPatternBreaksOverlap')), 1),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_Select, {
              placeholder: _ctx.t('placeholderSelect'),
              modelValue: 
            _ctx.workingStyleMasterParams.working_style_standard
              .auto_break_and_shift_time_overlap
          ,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (
            _ctx.workingStyleMasterParams.working_style_standard
              .auto_break_and_shift_time_overlap
           = $event)),
              "options-select": _ctx.autoBreakAndPatternBreaksOverlapList,
              "item-value": "key",
              "item-text": "value"
            }, null, 8, ["placeholder", "modelValue", "options-select"])
          ]),
          (
          _ctx.workingStyleMasterParams.working_style_standard
            .auto_break_and_shift_time_overlap ===
          _ctx.AUTO_BREAK_AND_SHIFT_TIME_OVERLAP_TYPE.WORK_PATTERNS_IS_BREAK
        )
            ? (_openBlock(), _createBlock(_component_Checkbox, {
                key: 0,
                label: _ctx.t('takeAnAutomaticBreak'),
                modelValue: 
          _ctx.workingStyleMasterParams.working_style_standard
            .is_shift_pattern_break_time_setting
        ,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
          _ctx.workingStyleMasterParams.working_style_standard
            .is_shift_pattern_break_time_setting
         = $event))
              }, null, 8, ["label", "modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.workingStyleMasterParams.is_using_break_time === _ctx.USING_BREAK_TIME.USE &&
        _ctx.workingStyleMasterParams.break_type !== _ctx.BREAK_TYPE.STAMP_BREAK
      )
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('breakTimeWhenStampedBreaks')), 1),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_Select, {
              placeholder: _ctx.t('placeholderSelect'),
              modelValue: 
            _ctx.workingStyleMasterParams.working_style_standard
              .break_with_check_time
          ,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (
            _ctx.workingStyleMasterParams.working_style_standard
              .break_with_check_time
           = $event)),
              "options-select": _ctx.typeBreakForStampBreakList,
              "item-value": "key",
              "item-text": "value"
            }, null, 8, ["placeholder", "modelValue", "options-select"])
          ])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.workingStyleMasterParams.is_using_break_time === _ctx.USING_BREAK_TIME.USE &&
        _ctx.workingStyleMasterParams.break_type === _ctx.BREAK_TYPE.STAMP_BREAK
      )
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('stampBreakAndPatternOverlap')), 1),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_Select, {
              placeholder: _ctx.t('placeholderSelect'),
              modelValue: 
            _ctx.workingStyleMasterParams.working_style_standard
              .check_time_and_shift_time_overlap
          ,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
            _ctx.workingStyleMasterParams.working_style_standard
              .check_time_and_shift_time_overlap
           = $event)),
              "options-select": _ctx.stampBreakAndPatternOverlapList,
              "item-value": "key",
              "item-text": "value"
            }, null, 8, ["placeholder", "modelValue", "options-select"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}